module.exports = __webpack_public_path__ + "img/nodata.14624aa2.png";